import {useCallback} from 'react'
import {useSelector} from 'react-redux'
import {buildOfferCheckApiParams} from 'modules/accommodation/buildOfferCheckApiParams'
import {getOfferCheckRoomsHeaders} from 'modules/accommodation/selectors'
import {getCommonPaymentPageLandingParams} from 'modules/searchApi/selectors'

import {getBovioApiKey} from '@vio/core/src/experiments/modules/selectors'
import {Offer} from '@vio/core/src/offer/types/offer'
import {Room, SplitBooking} from '@vio/core/src/room/types/room'

export const useGetComposedOfferCheckAPIParamsBuilder = () => {
  const headers = useSelector(getOfferCheckRoomsHeaders)
  const commonPaymentPageParams = useSelector(getCommonPaymentPageLandingParams)
  const apiKey = useSelector(getBovioApiKey)
  const buildOfferCheckParams = useCallback(
    ({
      offer,
      room,
      splitBooking
    }: {
      offer?: Offer
      room?: Pick<Room, 'name'>
      splitBooking?: SplitBooking
    }) =>
      buildOfferCheckApiParams({
        headers,
        commonPaymentPageParams,
        offer,
        room,
        splitBooking,
        apiKey
      }),
    [headers, commonPaymentPageParams, apiKey]
  )

  return {buildOfferCheckParams}
}
